<script setup>
import { ref } from 'vue'
import StatCard from '../../components/StatCard.vue'

const stats = ref({
  activeGames: {
    value: 24,
    change: 3,
    trend: 'up',
    icon: 'basketball-ball'
  },
  apiUsage: {
    value: '85%',
    change: 5,
    trend: 'up',
    icon: 'chart-line'
  },
  credits: {
    value: '250',
    change: -10,
    trend: 'down',
    icon: 'coins'
  }
})
</script>

<template>
  <div class="p-6">
    <div class="mb-8">
      <h1 class="text-2xl font-bold text-gray-900">Client Dashboard</h1>
      <p class="text-gray-500">Welcome to your OddsComposer dashboard</p>
    </div>

    <!-- Stats Grid -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      <StatCard
        v-for="(stat, key) in stats"
        :key="key"
        :title="key.replace(/([A-Z])/g, ' $1').trim()"
        :value="stat.value"
        :change="stat.change"
        :trend="stat.trend"
        :icon="stat.icon"
      />
    </div>

    <!-- Active Games -->
    <div class="bg-white rounded-lg shadow p-6">
      <h2 class="text-lg font-medium mb-4">Your Active Games</h2>
      <!-- Add game list here -->
    </div>
  </div>
</template> 